import React from "react";
import { makeStyles } from "@material-ui/styles";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import { TextField } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  formcontrol: {
    width: "100%",
    marginTop: "1rem",
  },
  outlined: {
    "& fieldSet": {
      borderColor: theme.app.borderColor,
    },
    "& label": {
      color: theme.app.contrastLabelColor,
    },
  },
}));

const MuiTextInput = (props) => {
  const {
    field,
    form: { touched, errors },
    placeholder,
    min,
    type,
    max,
    required,
    disabled,
    autoFocus,
    label,
    fullWidth,
    info,
    autocomplete,
  } = props;
  const classes = useStyles();
  return (
    <FormControl
      error={
        touched[field.name] &&
        errors[field.name] &&
        errors[field.name].length > 0
      }
      disabled={disabled}
      className={classes.formcontrol}
      variant="filled"
    >
      <TextField
        className={classes.outlined}
        label={label}
        {...field}
        autoFocus={autoFocus}
        placeholder={placeholder}
        required={required}
        max={max}
        min={min}
        type={type}
        fullWidth={fullWidth}
        variant="outlined"
        autoComplete={autocomplete ? autocomplete : ""}
      />

      {touched[field.name] && errors[field.name] ? (
        <FormHelperText filled role="alert" aria-live="assertive">
          {errors[field.name]}
        </FormHelperText>
      ) : (
        <FormHelperText filled>{info}</FormHelperText>
      )}
    </FormControl>
  );
};

export default MuiTextInput;
